// Due to the backwardness of the employee who initialized the project, there is this styles spaghetti, he
// installed the bootstrap package and also added the bootstrap styles in ./styles/bootstrap 🤡
// TODO uncomment import from boootstrap/dist 👇 and remove everything from /styles/bootstrap
// import "bootstrap/dist/css/bootstrap.css";
// ! Due to the large number of changes he made in /styles/bootstrap, the application will require significant styling adjustments
// ! after /styles/bootstrap removal.
import ReactDOM from "react-dom/client";
import "react-toastify/dist/ReactToastify.css";
import "style/bootstrap/bootstrap.min.css";
import "style/corners.css";
import "style/index.css";
import "style/details.css";
import "style/responsive.css";
import * as serviceWorker from "./serviceWorkerRegistration";
import { useServiceWorkerStore } from "features/ServiceWorker";
import App from "./app";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <div id="full">
    <App />
  </div>
);

const config = {
  onUpdate: (registration) => {
    if (registration && registration.waiting) {
      registration.waiting.postMessage({ type: "SKIP_WAITING" });
      useServiceWorkerStore.setState({ isUpdateAvailable: true });
    }
  },
  onSuccess: () => {
    useServiceWorkerStore.setState({ isUpdateAvailable: true });
  },
};

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register(config);
